import styled from 'styled-components';

export const GiftContainerStyled = styled.div`
  .product_item {
    margin-bottom: 20px;
    cursor: pointer;
  }
`;
